export const ServiceConnectedState = {
    Offline: 0,
    Connecting: 1,
    Online: 2,
    Reconnecting: 3,
} as const;

export type ServiceConnectedState = (typeof ServiceConnectedState)[keyof typeof ServiceConnectedState];
